import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Modal = ({
  confirmText,
  cancelText,
  hideClose,
  title,
  hideCancelBtn,
  children,
  onClose,
  onSubmit,
  open,
  classes,
  size = "lg",
  hideFooter,
  center,
}) => {
  if (!open) return null;
  const centerClass =
    "top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] ";
  return (
    <div
      className={"z-10 " + (classes?.wrapper || "")}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/**
  Background backdrop, show/hide based on modal state.

  Entering: "ease-out duration-300"
    From: "opacity-0"
    To: "opacity-100"
  Leaving: "ease-in duration-200"
    From: "opacity-100"
    To: "opacity-0"
*/}
      <div
        className={`z-10 fixed inset-0 bg-black bg-opacity-75 transition-opacity ${
          classes?.backdrop || ""
        }`}
      ></div>

      <div
        className={`fixed w-full max-w-xs inset-0 top-15 z-10 overflow-y-auto ${
          classes?.body || ""
        } ${center ? centerClass : ""}`}
      >
        <div className="flex items-end justify-center p-4 text-center sm:items-center sm:p-0">
          {/**
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
*/}
          <div
            className={`relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:w-full max-w-lg ${size} `}
          >
            {(title || !hideClose) && (
              <div className="bg-primary relative min-h-[60px] px-4 py-4 flex items-cente">
                {title}
                {!hideClose && (
                  <FontAwesomeIcon
                    icon={faClose}
                    onClick={onClose}
                    className="absolute top-5 right-5 cursor-pointer"
                  ></FontAwesomeIcon>
                )}
              </div>
            )}

            <div className="bg-white p-8">
              <div className="pb-4">{children}</div>
              {(!!onSubmit || !hideCancelBtn) && !hideFooter && (
                <div className={`pt-3 sm:flex space-x-3 ${classes?.footer}`}>
                  {!!onSubmit && (
                    <button
                      type="submit"
                      onClick={onSubmit}
                      className="bg-black hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                    >
                      {confirmText || "Submit"}
                    </button>
                  )}
                  {!hideCancelBtn && (
                    <button
                      onClick={onClose}
                      className="bg-black hover:bg-blue-600 text-white font-bold py-2 px-4 rounded inline-flex items-center"
                    >
                      {cancelText || "Cancel"}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
